export const GET_CURRENT_USER_REQUEST = 'USER/GET_CURRENT_USER_REQUEST';
export const GET_CURRENT_USER_SUCCESS = 'USER/GET_CURRENT_USER_SUCCESS';
export const GET_CURRENT_USER_ERROR = 'USER/GET_CURRENT_USER_ERROR';

export const UPDATE_USER = 'USER/UPDATE_USER';
export const UPDATE_USER_REQUEST = 'USER/UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'USER/UPDATE_USER_SUCCESS';
export const UPDATE_USER_ERROR = 'USER/UPDATE_USER_ERROR';

export const UPDATE_USER_EMAIL = 'USER/UPDATE_USER_EMAIL';

export const RESET_USER_DATA = 'USER/RESET_USER_DATA';

export const GET_USER_FEATURES = 'USER/GET_USER_FEATURES';
export const SET_USER_FEATURES = 'USER/SET_USER_FEATURES';

export const SET_USER_AB_TEST_PERCENTAGE = 'USER/SET_USER_AB_TEST_PERCENTAGE';

export const POST_GOOGLE_ANALYTICS_ID = 'USER/POST_GOOGLE_ANALYTICS_ID';

export const GET_USER_PERSONALISATION = 'USER/GET_USER_PERSONALISATION';
export const GET_USER_PERSONALISATION_REQUEST = 'USER/GET_USER_PERSONALISATION_REQUEST';
export const GET_USER_PERSONALISATION_SUCCESS = 'USER/GET_USER_PERSONALISATION_SUCCESS';
export const GET_USER_PERSONALISATION_ERROR = 'USER/GET_USER_PERSONALISATION_ERROR';

export const UPDATE_USER_PERSONALISATION = 'USER/UPDATE_USER_PERSONALISATION';
export const UPDATE_USER_PERSONALISATION_REQUEST = 'USER/UPDATE_USER_PERSONALISATION_REQUEST';
export const UPDATE_USER_PERSONALISATION_SUCCESS = 'USER/UPDATE_USER_PERSONALISATION_SUCCESS';
export const UPDATE_USER_PERSONALISATION_ERROR = 'USER/UPDATE_USER_PERSONALISATION_ERROR';

export const OPEN_SUPPORT_FORM = 'USER/OPEN_SUPPORT_FORM';
export const OPEN_SUPPORT_FORM_REQUEST = 'USER/OPEN_SUPPORT_FORM_REQUEST';
export const OPEN_SUPPORT_FORM_SUCCESS = 'USER/OPEN_SUPPORT_FORM_SUCCESS';

export const CLOSE_CHATBOT = 'USER/CLOSE_CHATBOT';

export const GET_USER_WEB_ANALYTICS_REQUEST = 'USER/GET_USER_WEB_ANALYTICS_REQUEST';
export const GET_USER_WEB_ANALYTICS_SUCCESS = 'USER/GET_USER_WEB_ANALYTICS_SUCCESS';
export const GET_USER_WEB_ANALYTICS_ERROR = 'USER/GET_USER_WEB_ANALYTICS_ERROR';
